import { render, staticRenderFns } from "./ControlesAntisoborno.vue?vue&type=template&id=af52eb52&"
import script from "./ControlesAntisoborno.vue?vue&type=script&lang=js&"
export * from "./ControlesAntisoborno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports